// @ts-strict-ignore
import type {Expression, Operand, Operator} from '../types/expression-types';
import type {Serializable} from '../types/serialized-cohort-types';
import {ExpressionNode} from './expression-node';
import {OperandNode} from './operand-node';

export class OperatorNode extends ExpressionNode implements Serializable {
  public static parseExpression(expression: Expression | Operand): ExpressionNode {
    if (expression) {
      if (OperatorNode.isExpression(expression)) {
        const [left, right] = expression.children;
        return new OperatorNode(
          expression.operator,
          OperatorNode.parseExpression(left),
          OperatorNode.parseExpression(right),
        );
      }
      const operand = expression;
      return new OperandNode(operand);
    }

    return null;
  }

  private static isExpression(expression: Expression | Operand): expression is Expression {
    return (expression as Expression).operator !== undefined;
  }

  constructor(
    public operator: Operator,
    public left: ExpressionNode,
    public right: ExpressionNode,
  ) {
    super(left, right);
  }

  public serialize(): Expression {
    return {
      children: [this.left, this.right].filter(Boolean).map((child) => child.serialize()),
      operator: this.operator,
    };
  }
}
